import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { FileProgress } from '@app/core/models/shared/file-progress.model';

@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {

    private fileProgressedSubject$ = new BehaviorSubject<FileProgress>(null);
    public fileProgressed$ = this.fileProgressedSubject$.asObservable();

    constructor() {
    }

    downloadBlob(blob: Blob, fileName: string, mimeType?: string): void {
        if (_.isNil(mimeType)) {
            this.downloadFile(new File([blob], fileName));
        }

        this.downloadFile(new File([blob], fileName, { type: mimeType }));
    }

    downloadFile(file: File): void {
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(file);
            return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(file);

        var link = document.createElement('a');
        link.href = data;
        link.download = file.name;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
        }, 100);
    }

    reportProgress(requestId: string, loaded: number, total: number) {
        this.fileProgressedSubject$.next(new FileProgress(requestId, loaded, total));
    }

}
